import {React, useEffect} from 'react';
import { useParams, Link } from 'react-router-dom';
import ProfileJobHeader from './ProfileJobHeader/ProfileJobHeader';
import DetailBoxJob from './DetailBoxJob/DetailBoxJob';
import DetailBoxLargeJob from './DetailBoxLargeJob/DetailBoxLargeJob';
import DetailDeepBoxJob from './DetailDeepBoxJob/DetailDeepBoxJob';
import DetailMidBoxJob from './DetailMidBoxJob/DetailMidBoxJob';
import './jobDetail.css';
import RecommendedJobsDetail from './RecommendedJobsDetail/RecommendedJobsDetail';
import useFetchJobOffer from '../../../hooks/jobs/useFetchJobOffer';
import LocationMap from '../../Shared/Map/LocationMap'

const JobDetail = () => {
  const { id } = useParams();
  const { jobOffer, loading, error } = useFetchJobOffer(id);
  
  if (loading) {
    return (
      <div className="job-detail__loading-container fade-in">
        <div className="job-detail__loading-spinner"></div>
        <p className="job-detail__loading-text">Cargando...</p>
      </div>
    );
  }

  if (error) return <div>Error: {error}</div>;
  if (!jobOffer) return <div>Job offer not available</div>;

  return (
    <div>
      <ProfileJobHeader data={jobOffer.headerData} />
      <div className="container">
        <div className="job-detail__principal-container">
          <div className="job-detail__information-container">
            <DetailBoxJob title="INFORMACIÓN" id="detail-box-job__large" data={jobOffer.informationData} />
            <DetailBoxJob title="CONDICIONES" data={jobOffer.conditionsData} />
          </div>
          <div className="job-detail__information-right-container">
            <DetailDeepBoxJob title="DESCRIPCIÓN" data={jobOffer.description} />
            <DetailBoxLargeJob 
              title="BENEFICIOS" 
              data = {[
                "Seguro",
                "Traslado",
                "Uniforme",
                "Capacitaciones",
                "Colación",
                "Formación",
                "Cumpleaños libre",
                "Convenios externos",
                "Descuentos corporativos",
                "Contratos corporativos",
                "Otras"
              ]}
              checkedBenefits={jobOffer.benefits} 
            />
            <DetailDeepBoxJob title="FUNCIONES" data={jobOffer.functions} />
          </div>
        </div>

        <div className="job-detail__secondary-container">
          <div className="job-detail__bottom-container">
            <DetailMidBoxJob title="REQUISITOS" data={jobOffer.requirements} />
            <div className="job-detail__location-container">
              <LocationMap 
                locations={Array.isArray(jobOffer.location) ? jobOffer.location : []} 
                type={"job"}
              />
            </div>
          </div>
        </div>

        <div className="job-detail__apply-container">
          <h1>¿Te interesó esta oferta?</h1>
          <button className="job-detail__apply-button">
            <Link to={`/trabajos/${id}/aplicar`} className="job-detail__apply-button-link">
              Postular ahora
            </Link>
          </button>
        </div>
        
        <div className="job-detail__recommended-jobs">
          <RecommendedJobsDetail />
        </div>
      </div>
    </div>
  );
};

export default JobDetail;

